import { SupportedLocale } from '../enums/supported-locale.enum';
export function getLanguageCodeFromLocale(locale) {
    return locale === SupportedLocale.ENGLISH ? 'en' : locale;
}
